<template>
  <div style="width: 100%">
    <q-slider
        v-if="editableFormat"
        :value="quality"
        @change="val => { quality = val }"
        :min="5"
        :max="maxQuality"
        :step="1"
        :label-always="true"
        :label-value="size | formatSize"
        snap
    />
    <div id="cont"
        :class="{realSize: realSize, 'cursor-zoom-in': !realSize && !disableRealSize, 'cursor-zoom-out': realSize && !disableRealSize}"
        :style="{maxHeight: divMaxHeight}"
        @click="changeRealSize"

    >
      <q-resize-observable @resize="onDivResize" />
      <canvas
          v-if="editableFormat"
          id="canvas"
          :style="{ maxHeight: imgMaxHeight }"
          :class="{realSize: realSize}"
          :width="naturalWidth"
          :height="naturalHeight"
      >
      </canvas>
      <img
          v-show="!editableFormat"
          id="img"
          :style="{ maxHeight: imgMaxHeight }"
          :src="url"
          :class="{realSize: realSize}"
          @load="init"
      >
    </div>
  </div>
</template>
<style scoped>
  img, canvas {
    max-width: 100%;
  }
  img.realSize, canvas.realSize {
    max-width: unset;
  }
  div.realSize {
    overflow: auto;
  }
  .q-slider {
    padding: 0 22px;
  }
</style>
<script type="text/babel">

export default {
  name: 'picResize',
  components: {
  },
  props: {
    maxHeight: {
      type: Number,
      required: true,
    },
    maxQuality: {
      type: Number,
      required: true,
    },
    url: {
      required: true,
    },
    editableFormat: {
      type: String,
    },
    picIniSize: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      quality: 101,
      image: null,
      blob: null,
      canvas: null,
      ctx: null,
      initialHeight: null,
      initialWidth: null,
      naturalHeight: null,
      naturalWidth: null,
      width: null,
      height: null,
      realSize: false,
      size: this.picIniSize,
    };
  },
  computed: {
    disableRealSize() {
      return (this.height >= this.naturalHeight - 5) && (this.width >= this.naturalWidth - 5); // 5px don't matter
    },
    blobFormat() {
      return this.editableFormat === 'bmp' ? 'png' : this.editableFormat;
    },
    divMaxHeight() {
      return `${this.maxHeight - (this.editableFormat ? 40 : 0)}px`;
    },
    imgMaxHeight() {
      return this.realSize ? 'unset' : this.divMaxHeight;
    },
  },
  watch: {
    disableRealSize: {
      handler(value) {
        console.log('disableRealSize', value);
        if (value) {
          this.realSize = false;
        }
      },
      immediate: false,
    },
    quality(value) {
      if (value === 101) {
        this.naturalHeight = this.initialHeight;
        this.naturalWidth = this.initialWidth;
      } else {
        this.naturalHeight = (this.initialHeight / 100) * value;
        this.naturalWidth = (this.initialWidth / 100) * value;
      }
      const image = document.getElementById('img');
      this.$nextTick(() => {
        this.ctx.drawImage(image, 0, 0, this.naturalWidth, this.naturalHeight);
        if (value === 101) {
          this.blob = null;
          this.size = this.picIniSize;
          this.$emit('input', null);
        } else {
          this.getBlob();
        }
      });
    },
  },
  methods: {
    changeRealSize(e) {
      this.realSize = !this.realSize && !this.disableRealSize;
      if (this.realSize) {
        const div = document.getElementById('cont');
        const rect = div.getBoundingClientRect();
        const xRel = ((e.clientX - rect.x) / rect.width);
        const yRel = ((e.clientY - rect.y) / rect.height);
        this.$nextTick(() => {
          const rect2 = div.getBoundingClientRect();
          div.scrollLeft = (xRel * this.naturalWidth) - (rect2.width / 2);
          div.scrollTop = (yRel * this.naturalHeight) - (rect2.height / 2);
        });
      }
    },
    onDivResize(size) {
      console.log('onDivResize', size);
      this.width = size.width;
      this.height = size.height;
    },
    init() {
      this.quality = this.maxQuality; // 101 if initial picture, 100 if cropped or rotated
      console.log('picResize INIT this.quality, this.maxQuality;', this.quality, this.maxQuality);
      const image = document.getElementById('img');
      this.naturalHeight = image.naturalHeight;
      this.naturalWidth = image.naturalWidth;
      this.initialHeight = this.naturalHeight;
      this.initialWidth = this.naturalWidth;
      if (this.editableFormat) {
        this.$nextTick(() => {
          this.canvas = document.getElementById('canvas');
          this.ctx = this.canvas.getContext('2d');
          this.ctx.drawImage(image, 0, 0);
        });
      }
    },
    getBlob() {
      return new Promise((resolve) => {
        this.canvas.toBlob(
          (blob) => {
            this.blob = blob;
            this.$emit('input', this.blob);
            console.log('blob', blob.size, blob.type);
            this.size = blob.size;
            resolve(blob);
          },
          `image/${this.blobFormat}`,
        );
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pic-resize.vue